import { render } from "./AccountMinusOutline.vue?vue&type=template&id=ab4cc598"
import script from "./AccountMinusOutline.vue?vue&type=script&lang=js"
export * from "./AccountMinusOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__